import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';

// No `password` field: the API strips credentials before serialising a user
// (server/shared/users/publicUser.ts). Declaring it here would describe a
// value that never arrives and invite code to read `undefined`.
export type TUser = {
  _id: string;
  firstName: string;
  status: string;
  email: string;
  branch: string;
  imageUrl: string;
  role: string;
  resources: string[];
  followings: string[];
  courses: string[];
  lastLoginDate: string;
  createdAt: string;
  updatedAt: string;
  mfaEnabled?: boolean;
};

export const useUser = () => {
  return useQuery('user', async () => {
    const response = await service.get('/user');
    return response.data.data as TUser;
  });
};
